<template>
  <div class="md-layout">
    <div class="md-layout-item">
      <!-- Summary Stats Cards -->
      <div class="md-layout md-gutter">
        <div class="md-layout-item md-size-20 md-small-size-100">
          <md-card class="stat-card">
            <md-card-content>
              <div class="stat-icon total">📊</div>
              <div class="stat-value">{{ stats.totalTransactions }}</div>
              <div class="stat-label">Total Transactions</div>
            </md-card-content>
          </md-card>
        </div>
        <div class="md-layout-item md-size-20 md-small-size-100">
          <md-card class="stat-card">
            <md-card-content>
              <div class="stat-icon pending">⏳</div>
              <div class="stat-value">{{ stats.pendingCount }}</div>
              <div class="stat-label">Pending</div>
            </md-card-content>
          </md-card>
        </div>
        <div class="md-layout-item md-size-20 md-small-size-100">
          <md-card class="stat-card">
            <md-card-content>
              <div class="stat-icon validated">✅</div>
              <div class="stat-value">{{ stats.validatedCount }}</div>
              <div class="stat-label">Validated</div>
            </md-card-content>
          </md-card>
        </div>
        <div class="md-layout-item md-size-20 md-small-size-100">
          <md-card class="stat-card">
            <md-card-content>
              <div class="stat-icon redeemed">🎁</div>
              <div class="stat-value">{{ stats.redeemedCount }}</div>
              <div class="stat-label">Redeemed</div>
            </md-card-content>
          </md-card>
        </div>
        <div class="md-layout-item md-size-20 md-small-size-100">
          <md-card class="stat-card">
            <md-card-content>
              <div class="stat-icon discount">💰</div>
              <div class="stat-value">£{{ stats.totalDiscountGiven.toFixed(2) }}</div>
              <div class="stat-label">Total Discounts</div>
            </md-card-content>
          </md-card>
        </div>
      </div>

      <!-- Release Reward Modal -->
      <md-dialog :md-active.sync="releaseModal" :md-fullscreen="false">
        <md-dialog-title>Release Reward</md-dialog-title>
        <md-dialog-content>
          <div class="reward-modal-content">
            <p v-if="selectedTransaction">
              <strong>Referrer:</strong> {{ selectedTransaction.userEmail }}
            </p>
            <p v-if="selectedTransaction">
              <strong>Order:</strong> {{ selectedTransaction.orderNumber }}
            </p>
            <p v-if="selectedTransaction">
              <strong>Amount:</strong> £{{ selectedTransaction.orderAmount.toFixed(2) }}
            </p>
            
            <div class="md-layout">
              <div class="md-layout-item md-size-100">
                <md-field>
                  <label>Reward Type</label>
                  <md-select v-model="rewardForm.rewardType" required>
                    <md-option value="subscription">Free Subscription</md-option>
                    <md-option value="accessory">Accessory Product</md-option>
                  </md-select>
                </md-field>
              </div>

              <div class="md-layout-item md-size-100" v-if="rewardForm.rewardType === 'subscription'">
                <md-field>
                  <label>Free Months</label>
                  <md-input type="number" min="1" v-model.number="rewardForm.freeMonths" required></md-input>
                </md-field>
              </div>

              <div class="md-layout-item md-size-100" v-if="rewardForm.rewardType === 'accessory'">
                <md-field>
                  <label>Accessory Product Name</label>
                  <md-input type="text" v-model="rewardForm.accessoryName" required></md-input>
                </md-field>
              </div>

              <div class="md-layout-item md-size-100">
                <md-field>
                  <label>Admin Notes (Optional)</label>
                  <md-textarea v-model="rewardForm.adminNotes" :rows="3"></md-textarea>
                </md-field>
              </div>
            </div>
          </div>
        </md-dialog-content>
        <md-dialog-actions>
          <md-button @click="releaseModal = false" :disabled="isProcessing">Cancel</md-button>
          <md-button class="md-primary md-raised" @click="confirmRelease" :disabled="isProcessing">
            <span v-if="!isProcessing">Release Reward</span>
            <span v-else><i class="fa fa-spinner fa-spin"></i> Processing...</span>
          </md-button>
        </md-dialog-actions>
      </md-dialog>

      <!-- Filters Card -->
      <md-card>
        <md-card-header class="md-card-header-icon md-card-header-green">
          <div class="card-icon">
            <md-icon>card_giftcard</md-icon>
          </div>
          <h4 class="title">Referral Transactions</h4>
        </md-card-header>
        <md-card-content>
          <div class="md-layout">
            <div class="md-layout-item md-size-25">
              <md-field>
                <md-input type="text" placeholder="Referral Code" v-model="filters.referralCode"></md-input>
              </md-field>
            </div>

            <div class="md-layout-item md-size-25">
              <md-field>
                <md-input type="text" placeholder="Referrer Email" v-model="filters.userEmail"></md-input>
              </md-field>
            </div>

            <div class="md-layout-item md-size-25">
              <md-field>
                <md-input type="text" placeholder="Referee Email" v-model="filters.refereeEmail"></md-input>
              </md-field>
            </div>

            <div class="md-layout-item md-size-25">
              <md-field>
                <md-input type="text" placeholder="Order Number" v-model="filters.orderNumber"></md-input>
              </md-field>
            </div>

            <div class="md-layout-item md-size-20">
              <md-field>
                <label>Status</label>
                <md-select v-model="filters.status">
                  <md-option value="">All Statuses</md-option>
                  <md-option value="pending">Pending</md-option>
                  <md-option value="validated">Validated</md-option>
                  <md-option value="released">Released</md-option>
                  <md-option value="claimed">Claimed</md-option>
                  <md-option value="cancelled">Cancelled</md-option>
                </md-select>
              </md-field>
            </div>

            <div class="md-layout-item md-size-20">
              <md-field>
                <label>Redeemed</label>
                <md-select v-model="filters.rewardRedeemed">
                  <md-option value="">All</md-option>
                  <md-option value="true">Redeemed</md-option>
                  <md-option value="false">Not Redeemed</md-option>
                </md-select>
              </md-field>
            </div>

            <div class="md-layout-item md-size-20">
              <md-field>
                <label>From Date</label>
                <md-input type="date" v-model="filters.fromDate"></md-input>
              </md-field>
            </div>

            <div class="md-layout-item md-size-20">
              <md-field>
                <label>To Date</label>
                <md-input type="date" v-model="filters.toDate"></md-input>
              </md-field>
            </div>

            <div class="md-layout-item md-size-20">
              <md-button class="md-primary" :disabled="isDisabled" @click="loadTransactions()">
                Search
              </md-button>
              <md-button class="md-simple" @click="resetFilters()">Reset</md-button>
            </div>
          </div>

          <hr>

          <md-table
            :value="queriedData"
            :md-sort.sync="currentSort"
            :md-sort-order.sync="currentSortOrder"
            :md-sort-fn="customSort"
            class="paginated-table table-striped table-hover"
          >
            <md-table-toolbar>
              <md-field>
                <label for="pages">Per page</label>
                <md-select v-model="pagination.perPage" name="pages">
                  <md-option
                    v-for="item in pagination.perPageOptions"
                    :key="item"
                    :label="item"
                    :value="item"
                  >
                    {{ item }}
                  </md-option>
                </md-select>
              </md-field>
              <md-button class="md-primary md-dense" @click="exportData()">
                <md-icon>download</md-icon> Export
              </md-button>
            </md-table-toolbar>

            <md-table-row slot="md-table-row" slot-scope="{ item }">
              <md-table-cell md-label="Referral Code" md-sort-by="referralCode">
                <span class="referral-code-badge">{{ item.referralCode }}</span>
              </md-table-cell>

              <md-table-cell md-label="Referrer" md-sort-by="userEmail">
                <div v-if="item.beneficiary && item.beneficiary.isDelegated">
                  <strong class="parent-user">{{ item.beneficiary.parentUserEmail }}</strong>
                  <br>
                  <small class="delegated-badge">
                    🔗 via delegated: {{ item.beneficiary.delegatedUserEmail }}
                  </small>
                </div>
                <strong v-else>{{ item.userEmail }}</strong>
              </md-table-cell>

              <md-table-cell md-label="Referee" md-sort-by="refereeEmail">
                {{ item.refereeEmail }}
              </md-table-cell>

              <md-table-cell md-label="Order" md-sort-by="orderNumber">
                
                  <a v-if="item.orderInfo"
                  href="javascript:void(0)"
                  @click="$router.push({ path: '/kid/order-detail', query: { id: item.orderInfo._id }})"
                >
                  {{ item.orderNumber }}
                </a>
                <span v-else>{{ item.orderNumber || 'N/A' }}</span>
                <br>
                <small>£{{ item.orderAmount.toFixed(2) }}</small>
              </md-table-cell>

              <md-table-cell md-label="Discount">
                <span class="discount-badge">{{ item.discountPercent }}%</span>
                <br>
                <small>£{{ item.discountAmount.toFixed(2) }}</small>
              </md-table-cell>

              <md-table-cell md-label="Status" md-sort-by="status">
                <span :class="statusClass(item.status)">
                  {{ getStatusLabel(item.status) }}
                </span>
                <div v-if="item.status === 'pending' && item.daysUntilValidation !== null" class="days-remaining">
                  {{ item.daysUntilValidation > 0 ? item.daysUntilValidation + ' days left' : 'Ready to validate' }}
                </div>
                <div v-if="item.status === 'released' && !item.rewardClaimed" class="claim-status">
                  ⏳ Awaiting user claim
                </div>
                <div v-if="item.status === 'claimed'" class="claim-status claimed">
                  ✓ Claimed {{ formatDate(item.claimedAt) }}
                </div>
              </md-table-cell>

              <md-table-cell md-label="Reward">
                <div v-if="item.status === 'validated' || item.status === 'released' || item.status === 'claimed'">
                  <div v-if="item.rewardReleased">
                    <span class="reward-type-badge">
                      {{ item.rewardType === 'subscription' ? '📅' : '🎁' }}
                      {{ item.rewardType === 'subscription' ? item.freeMonths + ' Month(s) Free' : item.accessoryName }}
                    </span>
                    <br>
                    <small class="reward-value">Value: £{{ item.rewardValue }}</small>
                  </div>
                  <span v-else class="pending-reward-badge">
                    £{{ item.rewardValue }} Available
                  </span>
                </div>
                <span v-else class="text-muted">-</span>
              </md-table-cell>

              <md-table-cell md-label="Purchase Date" md-sort-by="purchaseDate">
                {{ HumanReadableDateFormat(item.purchaseDate) }}
              </md-table-cell>

              <md-table-cell md-label="Validation Date">
                <span v-if="item.status === 'pending'">
                  {{ formatDate(item.validationDate) }}
                </span>
                <span v-else-if="item.validatedAt">
                  {{ HumanReadableDateFormat(item.validatedAt) }}
                </span>
                <span v-else>-</span>
              </md-table-cell>

              <md-table-cell md-label="Actions">
                <md-button 
                  v-if="item.status === 'pending'"
                  class="md-icon-button md-success md-simple"
                  @click="approveTransaction(item)"
                  :disabled="isProcessing"
                  title="Approve Transaction"
                >
                  <md-icon>check_circle</md-icon>
                </md-button>

                <md-button 
                  v-if="item.status === 'validated' && !item.rewardReleased"
                  class="md-icon-button md-primary md-simple"
                  @click="openReleaseModal(item)"
                  :disabled="isProcessing"
                  title="Release Reward"
                >
                  <md-icon>card_giftcard</md-icon>
                </md-button>

                <md-icon 
                  v-if="item.status === 'released'"
                  class="released-icon"
                  title="Reward Released - Awaiting User Claim"
                >
                  hourglass_empty
                </md-icon>

                <md-icon 
                  v-if="item.status === 'claimed'"
                  class="claimed-icon"
                  title="Reward Claimed by User"
                >
                  done_all
                </md-icon>
              </md-table-cell>
            </md-table-row>
          </md-table>
        </md-card-content>

        <md-card-actions md-alignment="space-between">
          <div class="">
            <p class="card-category">
              Showing {{ from + 1 }} to {{ to }} of {{ total }} entries
            </p>
          </div>
          <pagination
            class="pagination-no-border pagination-success"
            v-model="pagination.currentPage"
            :per-page="pagination.perPage"
            :total="total"
          >
          </pagination>
        </md-card-actions>
      </md-card>
    </div>
  </div>
</template>
<script>
import { Pagination } from "@/components";
import OrdersDataService from "../../services/SuperAdmin/Kids/OrdersDataService";

export default {
  name: "ReferralTransactions",
  components: {
    Pagination,
  },
  data() {
    return {
      tableData: [],
      stats: {
        totalTransactions: 0,
        pendingCount: 0,
        validatedCount: 0,
        cancelledCount: 0,
        redeemedCount: 0,
        totalDiscountGiven: 0,
        totalRewardValue: 0,
      },
      filters: {
        referralCode: "",
        userEmail: "",
        refereeEmail: "",
        orderNumber: "",
        status: "",
        rewardRedeemed: "",
        fromDate: "",
        toDate: "",
      },
      currentSort: "purchaseDate",
      currentSortOrder: "desc",
      pagination: {
        perPage: 25,
        currentPage: 1,
        perPageOptions: [10, 25, 50, 100],
        total: 0,
      },
      isDisabled: false,
      isProcessing: false,
      releaseModal: false,
      selectedTransaction: null,
      rewardForm: {
        rewardType: 'subscription',
        freeMonths: 1,
        accessoryName: '',
        adminNotes: ''
      }
    };
  },
  computed: {
    queriedData() {
      return this.tableData.slice(this.from, this.to);
    },
    to() {
      let highBound = this.from + this.pagination.perPage;
      if (this.total < highBound) {
        highBound = this.total;
      }
      return highBound;
    },
    from() {
      return this.pagination.perPage * (this.pagination.currentPage - 1);
    },
    total() {
      return this.tableData.length;
    },
  },
  methods: {
    customSort(value) {
      return value.sort((a, b) => {
        const sortBy = this.currentSort;
        if (this.currentSortOrder === "desc") {
          return a[sortBy] > b[sortBy] ? -1 : 1;
        }
        return a[sortBy] > b[sortBy] ? 1 : -1;
      });
    },
    statusClass(status) {
      switch (status) {
        case "pending":    return "badge badge-warning";
        case "validated":  return "badge badge-success";
        case "released":   return "badge badge-primary";
        case "claimed":    return "badge badge-info";
        case "cancelled":  return "badge badge-danger";
        default:           return "badge badge-secondary";
      }
    },
    getStatusLabel(status) {
      const labels = {
        pending: 'Pending',
        validated: 'Validated',
        released: 'Released',
        claimed: 'Claimed',
        cancelled: 'Cancelled'
      };
      return labels[status] || status;
    },
    async approveTransaction(item) {
      if (!confirm(`Approve this referral transaction for ${item.userEmail}?\n\nOrder: ${item.orderNumber}\nAmount: £${item.orderAmount.toFixed(2)}`)) {
        return;
      }

      this.isProcessing = true;
      try {
        const response = await OrdersDataService.approveReferralTransaction({
          transactionId: item._id
        });
        this.$toast.success(response.data.respones_msg);
        this.loadTransactions();
      } catch (e) {
        this.$toast.error(e.response?.data?.respones_msg || "Error approving transaction");
      } finally {
        this.isProcessing = false;
      }
    },
    openReleaseModal(item) {
      this.selectedTransaction = item;
      this.rewardForm = {
        rewardType: 'subscription',
        freeMonths: 1,
        accessoryName: '',
        adminNotes: ''
      };
      this.releaseModal = true;
    },
    async confirmRelease() {
      // Validation
      if (this.rewardForm.rewardType === 'subscription' && (!this.rewardForm.freeMonths || this.rewardForm.freeMonths < 1)) {
        this.$toast.error("Please enter number of free months (minimum 1)");
        return;
      }

      if (this.rewardForm.rewardType === 'accessory' && !this.rewardForm.accessoryName.trim()) {
        this.$toast.error("Please enter accessory product name");
        return;
      }

      this.isProcessing = true;
      try {
        const response = await OrdersDataService.releaseReferralReward({
          transactionId: this.selectedTransaction._id,
          ...this.rewardForm
        });
        this.$toast.success(response.data.respones_msg);
        this.releaseModal = false;
        this.loadTransactions();
      } catch (e) {
        this.$toast.error(e.response?.data?.respones_msg || "Error releasing reward");
      } finally {
        this.isProcessing = false;
      }
    },
    loadTransactions() {
      this.isDisabled = true;
      OrdersDataService.referralTransactionsList(this.filters)
        .then((response) => {
          this.tableData = response.data.data;
          this.stats = response.data.stats;
          this.isDisabled = false;
        })
        .catch((e) => {
          this.$toast.error(e.response?.data?.respones_msg || "Error fetching transactions");
          this.isDisabled = false;
        });
    },
    resetFilters() {
      this.filters = {
        referralCode: "",
        userEmail: "",
        refereeEmail: "",
        orderNumber: "",
        status: "",
        rewardRedeemed: "",
        fromDate: "",
        toDate: "",
      };
      this.loadTransactions();
    },
    formatDate(date) {
      if (!date) return '-';
      return new Date(date).toLocaleDateString('en-GB', {
        day: '2-digit',
        month: 'short',
        year: 'numeric'
      });
    },
    exportData() {
      if (this.tableData.length === 0) {
        this.$toast.error("No data to export");
        return;
      }

      let csv = 'Referral Code,Referrer Email,Referee Email,Order Number,Order Amount,Discount %,Discount Amount,Status,Reward Type,Reward Details,Reward Value,Released,Claimed,Purchase Date,Validation Date\n';
      
      this.tableData.forEach((row) => {
        const rewardDetails = row.rewardType === 'subscription' 
          ? `${row.freeMonths} month(s)` 
          : row.accessoryName || 'N/A';

        csv += [
          row.referralCode,
          row.userEmail,
          row.refereeEmail,
          row.orderNumber || 'N/A',
          row.orderAmount.toFixed(2),
          row.discountPercent,
          row.discountAmount.toFixed(2),
          row.status,
          row.rewardType || 'N/A',
          rewardDetails,
          row.rewardValue || 0,
          row.rewardReleased ? 'Yes' : 'No',
          row.rewardClaimed ? 'Yes' : 'No',
          this.formatDate(row.purchaseDate),
          this.formatDate(row.validatedAt || row.validationDate),
        ].join(',') + '\n';
      });

      const anchor = document.createElement('a');
      anchor.href = 'data:text/csv;charset=utf-8,' + encodeURIComponent(csv);
      anchor.target = '_blank';
      anchor.download = 'referral-transactions.csv';
      anchor.click();
    },
  },
  beforeMount() {
    this.loadTransactions();
  },
};
</script>

<style scoped>
/* Stat Cards */
.stat-card {
  text-align: center;
  padding: 8px;
}
.stat-icon {
  font-size: 32px;
  margin-bottom: 8px;
}
.stat-value {
  font-size: 28px;
  font-weight: 700;
  color: #333;
}
.stat-label {
  font-size: 13px;
  color: #666;
  margin-top: 4px;
}

/* Modal */
.reward-modal-content {
  min-width: 400px;
}

/* Badges */
.referral-code-badge {
  display: inline-block;
  background: linear-gradient(135deg, #667eea 0%, #764ba2 100%);
  color: white;
  padding: 4px 12px;
  border-radius: 16px;
  font-weight: 600;
  font-size: 12px;
  letter-spacing: 0.5px;
}

.discount-badge {
  display: inline-block;
  background-color: #4caf50;
  color: white;
  padding: 3px 10px;
  border-radius: 12px;
  font-weight: 600;
  font-size: 11px;
}

.pending-reward-badge {
  display: inline-block;
  background-color: #fff3cd;
  color: #856404;
  padding: 3px 10px;
  border-radius: 12px;
  font-weight: 600;
  font-size: 11px;
  border: 1px solid #ffc107;
}

.reward-type-badge {
  display: inline-block;
  background-color: #e8f5e9;
  color: #2e7d32;
  padding: 4px 12px;
  border-radius: 12px;
  font-weight: 600;
  font-size: 11px;
  border: 1px solid #4caf50;
}

.reward-value {
  color: #666;
  font-size: 10px;
  font-weight: 500;
}

.days-remaining {
  font-size: 11px;
  color: #ff9800;
  margin-top: 4px;
  font-weight: 600;
}

.claim-status {
  font-size: 10px;
  color: #ff9800;
  margin-top: 4px;
  font-weight: 600;
}

.claim-status.claimed {
  color: #4caf50;
}

.text-muted {
  color: #999;
}

/* Table */
::v-deep .md-table-cell {
  word-wrap: break-word;
  white-space: normal;
  vertical-align: top;
}

.parent-user {
  color: #1976d2;
  font-weight: 700;
}

.delegated-badge {
  display: inline-block;
  margin-top: 4px;
  padding: 2px 8px;
  background-color: #e3f2fd;
  color: #1565c0;
  border-radius: 10px;
  font-size: 10px;
  border: 1px solid #90caf9;
}

/* Action Icons */
.released-icon {
  color: #2196f3;
  font-size: 20px;
}

.claimed-icon {
  color: #4caf50;
  font-size: 20px;
}
</style>